/** Local ringback while the parent's phone rings. 400 Hz, two short bursts, then a pause. */
export function createRingback() {
  let ctx = null;
  let timer = null;
  const live = [];

  function context() {
    if (typeof window === 'undefined') return null;
    if (!ctx || ctx.state === 'closed') {
      const AudioCtx = window.AudioContext || window.webkitAudioContext;
      if (!AudioCtx) return null;
      ctx = new AudioCtx();
    }
    return ctx;
  }

  function prime() {
    const audio = context();
    if (audio && audio.state === 'suspended') audio.resume();
  }

  function burst(audio, when, duration) {
    const osc = audio.createOscillator();
    const gain = audio.createGain();
    osc.type = 'sine';
    osc.frequency.value = 400;
    gain.gain.setValueAtTime(0.0001, when);
    gain.gain.exponentialRampToValueAtTime(0.07, when + 0.02);
    gain.gain.setValueAtTime(0.07, Math.max(when + 0.02, when + duration - 0.03));
    gain.gain.exponentialRampToValueAtTime(0.0001, when + duration);
    osc.connect(gain);
    gain.connect(audio.destination);
    osc.start(when);
    osc.stop(when + duration + 0.02);
    live.push(osc);
  }

  function start() {
    const audio = context();
    if (!audio || timer) return;
    if (audio.state === 'suspended') audio.resume();
    const ring = () => {
      const t = audio.currentTime + 0.05;
      burst(audio, t, 0.4);
      burst(audio, t + 0.6, 0.4);
    };
    ring();
    timer = setInterval(ring, 3000);
  }

  function stop() {
    if (timer) clearInterval(timer);
    timer = null;
    live.splice(0).forEach((osc) => {
      try { osc.stop(); } catch (_) { /* already stopped */ }
    });
    if (ctx && ctx.state !== 'closed') ctx.close().catch(() => {});
    ctx = null;
  }

  return { prime, start, stop };
}
